import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { ugcQuotationShape, userIdentityShape, catalogBibShape } from '@bibliocommons/bc-prop-types';
import { selectUserEntities } from 'app/selectors/EntitiesSelector';
import ModalActions from 'app/actions/ModalActions';

import QuotationDisplay from './QuotationDisplay';

export class QuotationDisplayContainer extends React.PureComponent {
  render() {
    return <QuotationDisplay {...this.props} />;
  }
}

QuotationDisplayContainer.propTypes = {
  // ownProps
  quotation: ugcQuotationShape.isRequired,
  displayStaffBadge: PropTypes.bool,
  catalogBib: catalogBibShape.isRequired,
  handleDeleteSuccess: PropTypes.func,

  // Redux props
  users: ImmutablePropTypes.mapOf(userIdentityShape).isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = state => ({
  users: selectUserEntities(state)
});

const mapDispatchToProps = dispatch => ({
  modalActions: bindActionCreators(ModalActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(QuotationDisplayContainer);
